import {useService} from '@cindedi/react-application';
import type {MetaFunction, LoaderFunction} from '@remix-run/node';
import {json} from '@remix-run/node';
import {Link, useLoaderData} from '@remix-run/react';
import {PublicLayout} from '~/domains/organization/components/PublicLayout';
import {seoMeta} from '~/domains/organization/utilities/seoMeta';

export interface TrabalhosLoaderData {
  productions: Research.PublicProductionDto[];
}

export const meta: MetaFunction = function TrabalhosMeta({matches}) {
  return seoMeta('trabalhos', {title: 'Trabalhos - Cindedi', description: 'Explore a produção acadêmica dos alunos do CINDEDI! Acesse dissertações e outros trabalhos que destacam nossa pesquisa em educação.'}, matches);
};

export const loader: LoaderFunction = async function TrabalhosLoader({context: {use}}) {
  const Production = use('Production');

  const productions = await Production.all();

  return json({
    productions: productions.sortByDesc('year'),
  });
};

export default function TrabalhosView() {
  const {productions} = useLoaderData<TrabalhosLoaderData>();
  useService('organization/titlebar').setTitle('Trabalhos');

  return (
    <PublicLayout>
      <ul role="list" className="flex flex-col gap-2">
        {productions.map((production) =>
          production.file ? (
            <li className="hover:bg-shade-3 bg-shade-2 rounded" key={production.id}>
              <Link to={production.file.url}>
                <div className="flex">
                  <div className="px-2 py-2 flex flex-col w-full">
                    <div className="flex flex-col text-shade-11 text-sm mb-1.5">
                      <div className="flex gap-2 items-center">
                        <span>{production.type}</span>•<span>{production.year}</span>
                      </div>
                    </div>
                    <span className="font-semibold text-primary-12">{production.title}</span>
                    <span>{production.author}</span>
                  </div>
                </div>
              </Link>
            </li>
          ) : (
            <li className="bg-shade-2 rounded" key={production.id}>
              <div className="flex">
                <div className="px-2 py-2 flex flex-col w-full">
                  <div className="flex gap-2 text-shade-11 text-sm items-center mb-1.5">
                    <span>{production.type}</span>•<span>{production.author}</span>
                  </div>
                  <span className="font-semibold text-primary-12">{production.title}</span>
                </div>
              </div>
            </li>
          ),
        )}
      </ul>
    </PublicLayout>
  );
}
